import React, { FunctionComponent } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import { CSSTransition } from "react-transition-group";
import {
  Wrapper,
  Container,
  Icon,
  Text,
} from "./styles/server-error-message-styles";

const EmailErrorMessage: FunctionComponent<unknown> = () => (
  <Wrapper>
    <CSSTransition in appear timeout={300} classNames="error-message-fade">
      <Container email>
        <Icon>
          <FontAwesomeIcon icon={faExclamationTriangle} />
        </Icon>
        <Text>
          <strong>Email error</strong>
          <br />
          Email has already been taken
        </Text>
      </Container>
    </CSSTransition>
  </Wrapper>
);

export default EmailErrorMessage;
